<template>
  <div class="dialog-scroll">
    <el-dialog
      :visible.sync="dialogVisible"
      class="search-popup"
      @close="resetForms"
      :before-close="handleDialogClose">
      <div class="title">{{ $t("title.popup.system.floor.search") }}</div>
      <!-- 検索 開始 -->

      <el-row>
        <el-form @submit.native.prevent :model="query" :rules="rules" ref="floorPopupRuleForm">
          <el-form-item prop="floorName" class="float-left">
            <el-input
              class="input-class"
              maxlength="50"
              size="small"
              v-model="query.floorName"
              :placeholder="$t('label.common.floorNamePlaceHolder')">
            </el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row class="form-group">
        <narrow-down @click="searchFloor">
          {{ $t("button.common.narrow") }}
        </narrow-down>
        <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
          {{ $t("button.common.cancelNarrow") }}
        </cancel-narrow-down>
      </el-row>


      <!-- 検索結果 開始 -->
      <div class="search-common" v-show="isshow">
        <label class="font-size-16 lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select @change="changePageSize" v-model="query.pageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div id="popup-floor-search-result" v-show="isshow" class="master-table-type">
        <el-table :data="searchResult.content">
          <el-table-column
            prop="floorName"
            :label="$t('label.popup.system.floor.label.floorName')"
            class-name="col-3"
          />
          <el-table-column
            prop="address"
            :label="$t('label.popup.system.floor.label.address')"
            class-name="col-15"
          />
          <el-table-column class-name="col-2">
            <div slot-scope="scope" class="detail-button with-100">
              <sp-smart-button @click="selectFloor(scope.row)" class="detailed-but with-100">
                {{ $t("button.common.select") }}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 検索結果 完了 -->
      <!-- ページ 开始 -->
      <pagination
        class="m-top-5"
        v-show="searchResult.content.length > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePageChange">
      </pagination>
      <!-- ページ 结束 -->
    </el-dialog>
  </div>
</template>

<script>
import PopupRulesFactory from "@/rules/rule-popup-floor";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;
const EVENT_ON_SELECTED = "on-selected";
export default {
  components: {
    Pagination: Pagination,
    narrowDown,
    cancelNarrowDown,
    SpSmartButton,
  },
  name: "FloorSearchPopup",
  props: {
    ownerIdParam: {
      type: String,
      default: null
    },
    buildingIdParam: {
      type: String,
      default: null
    },
    floorNameParam: {
      type: String,
      default: null
    },
    visible: Boolean,
    includeDeleteDataFlag: {
      type: Boolean,
      default: true
    },
    funcCode : {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      isshow: false,
      rules: PopupRulesFactory.popupRules(this),
      query: {
        ownerId: this.ownerIdParam,
        ownerName: null,
        ownerExId: null,
        buildingId: this.buildingIdParam,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floorName: this.floorNameParam,
        address: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        funcCode: this.funcCode,
      },
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        content: [],
      },
      dialogVisible: this.visible,
      isSearching: false,
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.query.ownerId = this.ownerIdParam;
      this.query.buildingId = this.buildingIdParam;
      this.query.floorName = this.floorNameParam;
    },
    // ownerIdParam: function (value) {
    //   this.query.ownerId = value;
    // },
    // buildingIdParam: function (value) {
    //   this.query.buildingId = value;
    // },
    // floorNameParam: function (value) {
    //   this.query.floorName = value;
    // }
  },
  methods: {
    resetForms() {
      this.$refs['floorPopupRuleForm'].resetFields()
    },
    changePageSize(){
      this.query.pageNumber = 1
      this.searchFloor()
    },

    searchFloor: function () {
      this.$refs["floorPopupRuleForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isSearching = true;
            this.showTableLoadingAnim();
            if(this.includeDeleteDataFlag == null) {
              this.includeDeleteDataFlag = true
            }
            SystemManageApi.searchFloor({
              ownerId: this.query.ownerId,
              ownerExId: this.query.ownerExId,
              ownerName: this.query.ownerName,
              buildingId: this.query.buildingId,
              buildingExId: this.query.buildingExId,
              buildingName: this.query.buildingName,
              floorName: this.query.floorName,
              floorId: this.query.floorId,
              includeDeleteDataFlag: this.includeDeleteDataFlag,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
              funcCode: this.query.funcCode
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then((resp) => {
              this.searchResult.pageNumber = resp.data.body.pageNumber;
              this.searchResult.totalPage = resp.data.body.totalPage;
              this.searchResult.totalCount = resp.data.body.totalCount;
              this.query.pageSize = resp.data.body.pageSize;
              this.searchResult.content = [];
              for (let body of resp.data.body.body) {
                this.searchResult.content.push({
                  ownerId: body.ownerId,
                  ownerExId: body.ownerExId,
                  ownerName: body.ownerName,
                  buildingId: body.buildingId,
                  buildingExId: body.buildingExId,
                  buildingName: body.buildingName,
                  floorName: body.floorName,
                  floorId: body.floorId,
                  address: body.ownerName + "　" + body.buildingName,
                });
              }
            }).finally(() => {
              this.isSearching = false;
              this.hideTableLoadingAnim();
            });
            this.isshow = true;
          }
        } else {
          return false;
        }
      });
    },

    selectFloor(floor) {
      this.$emit(EVENT_ON_SELECTED, floor);
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    /**
     * 清空检索条件
     */
    clearSearchParams: function () {
      this.query.floorName = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.searchResult.content = [];
      // this.$refs["floorPopupRuleForm"].resetFields();
      this.isshow = false;
    },

    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    handlePageChange: function (paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchFloor();
    },
    //显示表格加载动画
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-floor-search-result",
          background: "#ebebe6"
        });
      }
    },
    //隐藏表格加载动画
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  font-size: 24px;
  /* color: #2699fb; */
}
.allnumber {
  margin-left: 8px;
  margin-top: 34px;
  font-size: 12px;
  /* color: #3ba3fb; */
  margin-bottom: 11px;
}
.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  margin-top: -20px;
  font-size: 12px;
}

::v-deep .input-class {
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

.float-left {
  float: left;
}

.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  color: #fff;
  ::v-deep.el-input__inner {
    border: none;
    background-color: #f2f2ed;
    color: #525250;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
  .el-icon-arrow-up:before {
    color: #525250;
  }
}
.search-button {
  width: 67px !important;
  height: 19px !important;
}

.search-common {
  display: block;
  //float: right;
  text-align: right;
  margin-top: 36px;
  margin-bottom: 20px;
}

::v-deep .detail-button{
button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}

::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}
</style>
